import styled from 'styled-components';

export default styled.div`
  text-align: center;
  max-width: 100%;
  margin-top: 0.5rem;
  font-size: 0.8rem;
  cursor: pointer;
  user-select: none;
  padding: 0.5rem 0;

  &:hover {
    text-decoration: underline;
  }
  &:active {
    text-decoration: none;
  }
`;
